/**
 * Languages the platform writes organization-facing content in.
 * Mirrors the backend `CountryUtils.getLanguageForCountry` mapping, narrowed to
 * the languages we actually author (everything else falls back to Spanish).
 */
export type ContentLanguage = 'es' | 'pt' | 'en'

const PORTUGUESE_COUNTRIES = new Set(['BR', 'PT'])
const ENGLISH_COUNTRIES = new Set(['US', 'CA', 'GB', 'AU'])

export function languageForCountryCode(countryCode?: string | null): ContentLanguage {
    const code = countryCode?.trim().toUpperCase()
    if (!code) {
        return 'es'
    }
    if (PORTUGUESE_COUNTRIES.has(code)) {
        return 'pt'
    }
    if (ENGLISH_COUNTRIES.has(code)) {
        return 'en'
    }
    return 'es'
}

export type LocalizedContent = Partial<Record<ContentLanguage, string>>

/** Picks the requested language, then Spanish, then any non-empty value. */
export function resolveLocalizedContent(content: LocalizedContent | undefined, language: ContentLanguage): string {
    if (!content) {
        return ''
    }
    const direct = content[language]?.trim()
    if (direct) {
        return direct
    }
    const spanish = content.es?.trim()
    if (spanish) {
        return spanish
    }
    return Object.values(content).find((value) => typeof value === 'string' && value.trim().length > 0)?.trim() ?? ''
}
